import ClearingAPI from '@shared/api';

export const {
    positions: { getAssignedPosition },
} = ClearingAPI.settings;
